module.exports = __webpack_public_path__ + "static/media/tyre-yellow-two4.882e6961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-two4.png
// module id = 360
// module chunks = 0